import "./contactcard.scss"

export interface IContactCard {
    img:string
    title:string
    body:string
}

const ContactCard = ({img,title,body}:IContactCard) => {
    return (
        <div className="Contact-Card">
            <div className="Contact-Card-Image">
                <img src={img} alt="icon" className="img-fluid"/>
            </div>
            <div className="Contact-Card-Text">
                <h6>{title}</h6>
                <p>{body}</p>
            </div>
        </div>
    );
}

export default ContactCard;